module.exports = __webpack_public_path__ + "static/media/eye.ff926a8e.svg";